import TodayPage from './components/TodayPage/TodayPage';
import OverviewPage from './components/OverviewPage/OverviewPage';
import MattersPage from './components/MattersPage/MattersPage';
import MatterForm from './components/MatterForm/MatterForm';
import PatentJobForm from './components/PatentJobForm/PatentJobForm';
import JobsPage from './components/JobsPage/JobsPage';
import ToolsPage from './components/ToolsPage/ToolsPage';
import AntecedentCheckerPage from './components/AntecedentCheckerPage/AntecedentCheckerPage';
import DependencyCheckerPage from './components/DependencyCheckerPage/DependencyCheckerPage';
import JobEditorPage from './components/JobEditorPage/JobEditorPage';
import MatterEditorPage from './components/MatterEditorPage/MatterEditorPage';
import JobKindSettingsPage from './components/JobKindSettingsPage/JobKindSettingsPage';
import OAWorkspacePage from './components/OAWorkspacePage/OAWorkspacePage';
import OAProfilesPage from './components/OAProfilesPage/OAProfilesPage';
import LoginPage from './components/LoginPage/LoginPage';
import RequireAuth from './components/RequireAuth/RequireAuth';
import './theme/main.css';

const withAuth = (Component) => (props) =>
  <RequireAuth component={Component} {...props} />;

const applyConfig = (config) => {
  const appRoutes = [
    '/',
    '/today',
    '/overview',
    '/patent-dashboard',
    '/register-matter',
    '/matters',
    '/matter-editor',
    '/register-job',
    '/jobs',
    '/job-editor',
    '/oa-workspace',
    '/oa-profiles',
    '/job-kind-settings',
    '/tools',
    '/tool-antecedent',
    '/tool-dependency',
    '/login',
  ];

  config.addonRoutes = [
    ...(config.addonRoutes || []),
    {
      path: '/login',
      component: LoginPage,
      exact: true,
    },
    {
      path: '/',
      component: withAuth(TodayPage),
      exact: true,
    },
    {
      path: '/today',
      component: withAuth(TodayPage),
      exact: true,
    },
    {
      path: '/overview',
      component: withAuth(OverviewPage),
      exact: true,
    },
    {
      path: '/patent-dashboard',
      component: withAuth(OverviewPage),
      exact: true,
    },
    {
      path: '/register-matter',
      component: withAuth(MatterForm),
      exact: true,
    },
    {
      path: '/matters',
      component: withAuth(MattersPage),
      exact: true,
    },
    {
      path: '/matter-editor',
      component: withAuth(MatterEditorPage),
      exact: true,
    },
    {
      path: '/register-job',
      component: withAuth(PatentJobForm),
      exact: true,
    },
    {
      path: '/jobs',
      component: withAuth(JobsPage),
      exact: true,
    },
    {
      path: '/job-editor',
      component: withAuth(JobEditorPage),
      exact: true,
    },
    {
      path: '/oa-workspace',
      component: withAuth(OAWorkspacePage),
      exact: true,
    },
    {
      path: '/oa-profiles',
      component: withAuth(OAProfilesPage),
      exact: true,
    },
    {
      path: '/job-kind-settings',
      component: withAuth(JobKindSettingsPage),
      exact: true,
    },
    {
      path: '/tools',
      component: withAuth(ToolsPage),
      exact: true,
    },
    {
      path: '/tool-antecedent',
      component: withAuth(AntecedentCheckerPage),
      exact: true,
    },
    {
      path: '/tool-dependency',
      component: withAuth(DependencyCheckerPage),
      exact: true,
    },
  ];

  config.settings.nonContentRoutes = [
    ...(config.settings.nonContentRoutes || []),
    ...appRoutes,
  ];

  config.settings.nonContentRoutesPublic = [
    ...(config.settings.nonContentRoutesPublic || []),
    ...appRoutes,
  ];

  config.settings.supportedLanguages = Array.from(
    new Set([...(config.settings.supportedLanguages || []), 'ja']),
  );
  config.settings.defaultLanguage = 'ja';

  return config;
};

export default applyConfig;
